var render, staticRenderFns
import script from "./ChartPieValue.vue?vue&type=script&lang=ts&"
export * from "./ChartPieValue.vue?vue&type=script&lang=ts&"
import style0 from "./ChartPieValue.vue?vue&type=style&index=0&id=fc8d6d58&prod&scoped=true&lang=scss&"
import style1 from "./ChartPieValue.vue?vue&type=style&index=1&id=fc8d6d58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8d6d58",
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
